import type { DataExplorerResolver } from './types';

export function cn(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(' ');
}

export function resolveDataExplorerValue<TValue, TContext>(
  value: DataExplorerResolver<TValue, TContext> | undefined,
  context: TContext | undefined,
): TValue | undefined {
  if (typeof value === 'function') {
    return (value as (resolvedContext: TContext) => TValue)(context as TContext);
  }

  return value;
}
